import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const DisabledOutline = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='DisabledOutline' {...props}>
    <path fillRule='evenodd' clipRule='evenodd' d='M1 4C1 2.34315 2.34315 1 4 1H20C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4ZM4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4ZM6 11H18V13H6V11Z' fill='#000' />
  </StyledIcon>
);
